// extracted by mini-css-extract-plugin
export default {"girl":"Girl_girl__evIEX","panel":"Girl_panel__3MUzM"};